var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-skeleton"},[_c('b-skeleton-img',{staticClass:"mb-4 rounded",attrs:{"no-aspect":"","width":"100%","height":"240px"}}),_c('b-skeleton',{attrs:{"width":"65%"}}),_c('b-skeleton',{attrs:{"width":"85%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }